import React from 'react';
import style from './Footer.module.scss';

const Footer = () => {
	return <footer className={style.footer}>Made by SogetiLabs Paris. Copyright 2021.</footer>;
};

export default Footer;
